





































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import KriteriaIccuSvc from "@/services/KriteriaIccuService";
import { appModule } from "@/store/modules/app";
import { storeKriteriaIccu } from "@/store/modules/KriteriaIccuStore";
import { userModule } from "@/store/modules/user";

@Component({
	inject: { isReadOnly: { default: () => () => false } },
})
export default class KriteriaIccuPage extends Vue {
	@Prop() register!: string | number;
	@Prop() rm!: string | number;
	@Prop({ default: false }) isActive!: boolean;
	//  "all" = tampilkan semua step; "masuk"/"keluar" untuk split tab di IcuHcuPage
	@Prop({ default: "all" }) phase!: "masuk" | "keluar" | "all";
	isReadOnly!: () => boolean;

	get readOnly(): boolean {
		return this.isReadOnly();
	}

	step = 1;
	loaded = false;
	saving = false;
	deleting = false;
	deleteDialog = false;

	signDialog = false;
	signRole = "masuk";
	signPassword = "";
	showPassword = false;
	signError = "";
	signing = false;

	form: any = this.defaultForm();

	readonly masukCriteria = [
		{ key: "km_acs", label: "Acute Coronary Syndrome (STEMI / NSTEMI / UA)" },
		{
			key: "km_heart_failure",
			label: "Heart Failure (Acute Decompensated / Pulmonary Edema)",
		},
		{
			key: "km_aritmia",
			label:
				"Taki/bradiaritmia tidak stabil yang membutuhkan monitoring (VT, AF, PSVT, Bradikardi, AV Block, dll)",
		},
		{
			key: "km_hipertensi_emergency",
			label: "Hypertensive Emergency / Hypotension / Shock cardiogenic",
		},
		{ key: "km_post_arrest", label: "Post cardiac arrest / post resusitasi" },
		{
			key: "km_post_intervensi",
			label:
				"Monitoring pasca intervensi / prosedur invasif (PCI, Pemasangan TPM, Perikardiosentesis, DC cardioversion, dll)",
		},
		{ key: "km_transportable", label: "Pasien masuk ICCU transportable" },
		{ key: "km_lain", label: "Lain-lain" },
	];

	readonly keluarUmum = [
		{
			key: "ku_hemodinamik_24jam",
			label:
				"Hemodinamik stabil minimal 24 jam tanpa vasopresor / inotropik / titrasi vasodilator",
		},
		{
			key: "ku_no_iskemia",
			label:
				"Tidak ada iskemia miokard aktif, aritmia berulang, atau gagal jantung dekompensata",
		},
		{
			key: "ku_spo2_stabil",
			label:
				"Saturasi oksigen stabil (>94%) dengan O₂ <4 L/menit atau tanpa oksigen tambahan",
		},
		{
			key: "ku_kesadaran_baik",
			label:
				"Status kesadaran baik dan mampu mempertahankan jalan napas spontan",
		},
		{
			key: "ku_no_invasif",
			label:
				"Tidak memerlukan monitoring invasif kontinu (arterial line, CVP, Swan-Ganz, IABP)",
		},
		{
			key: "ku_no_resusitasi",
			label:
				"Tidak ada tindakan resusitasi atau observasi intensif dalam 24 jam terakhir",
		},
		{
			key: "ku_no_syringe",
			label: "Tidak memerlukan terapi intravena continue dengan syringe pump",
		},
	];

	readonly keluarSpesifik = [
		{
			grup: "Acute Coronary Syndrome (STEMI/NSTEMI)",
			butir: [
				{ key: "ks_acs_bebas_nyeri", label: "Bebas nyeri dada ≥24 jam" },
				{ key: "ks_acs_st_stabil", label: "ST segment stabil" },
				{ key: "ks_acs_no_aritmia", label: "Tidak ada aritmia signifikan" },
				{
					key: "ks_acs_hemodinamik_stabil",
					label: "Hemodinamik stabil tanpa inotropik",
				},
				{
					key: "ks_acs_post_pci_lancar",
					label: "Post-trombolisis/PCI tanpa komplikasi",
				},
			],
		},
		{
			grup: "Acute Heart Failure / Pulmonary Edema",
			butir: [
				{ key: "ks_ahf_no_sesak", label: "Tidak sesak saat istirahat" },
				{ key: "ks_ahf_rr_lt24", label: "RR <24x/menit" },
				{ key: "ks_ahf_spo2_gt94", label: "Saturasi >94%" },
				{ key: "ks_ahf_diuresis_adekuat", label: "Diuresis adekuat" },
				{ key: "ks_ahf_no_kongesti", label: "Tidak ada tanda kongesti berat" },
				{ key: "ks_ahf_elektrolit_stabil", label: "Elektrolit stabil" },
			],
		},
		{
			grup: "Arrhythmia (AF, VT, bradyarrhythmia)",
			butir: [
				{
					key: "ks_ar_ritme_stabil",
					label: "Ritme stabil ≥24 jam tanpa episode baru",
				},
				{
					key: "ks_ar_ventrikel_terkontrol",
					label: "Kecepatan ventrikel terkontrol",
				},
				{
					key: "ks_ar_alat_pacu_baik",
					label: "Alat pacu/terapi definitif berfungsi baik",
				},
			],
		},
		{
			grup: "Post Cardiac Arrest / Resusitasi",
			butir: [
				{ key: "ks_pca_neurologis_stabil", label: "Status neurologis stabil" },
				{
					key: "ks_pca_hemodinamik_stabil",
					label: "Hemodinamik stabil tanpa vasopresor",
				},
				{ key: "ks_pca_napas_baik", label: "Fungsi napas baik tanpa ventilator" },
			],
		},
		{
			grup: "Hypertensive / Hypotensive Emergency",
			butir: [
				{
					key: "ks_hte_td_stabil",
					label:
						"Tekanan darah stabil dalam target ±10–20 mmHg dari normal tanpa gejala organ target",
				},
			],
		},
		{
			grup: "Post Intervensi / Prosedur Invasif",
			butir: [
				{ key: "ks_pi_no_perdarahan", label: "Tidak ada perdarahan" },
				{ key: "ks_pi_no_infeksi", label: "Tidak ada infeksi" },
				{ key: "ks_pi_no_aritmia", label: "Tidak ada aritmia" },
				{ key: "ks_pi_no_hipotensi", label: "Tidak hipotensi pasca tindakan" },
				{
					key: "ks_pi_observasi_12jam",
					label: "Observasi pasca tindakan stabil ≥12 jam",
				},
			],
		},
	];

	get item() {
		return storeKriteriaIccu.currentItem;
	}

	get isCreator(): boolean {
		const rec: any = this.item;
		return !!rec && !!rec.created_by && Number(rec.created_by) === Number(userModule.user.id);
	}

	get canDelete(): boolean {
		const rec: any = this.item;
		if (!rec || !rec.id || this.readOnly) {
			return false;
		}
		return !rec.masuk_signed_at || this.isCreator;
	}

	get loading() {
		return storeKriteriaIccu.loading;
	}
	get masukLocked() {
		return this.item?.is_masuk_locked || false;
	}
	get keluarLocked() {
		return this.item?.is_keluar_locked || false;
	}
	get isMasukComplete() {
		return !!this.item?.masuk_signed_at;
	}
	get isKeluarComplete() {
		return !!this.item?.is_locked;
	}

	get masukError() {
		const c = this.masukCriteria.some((k) => this.form[k.key] === true);
		if (!c) return "Minimal 1 kriteria masuk harus dicentang";
		if (this.form.km_lain && !this.form.km_lain_text)
			return "Indikasi lain-lain harus diisi";
		return "";
	}
	get signTitle() {
		if (this.signRole === "masuk") return "Tanda Tangan Kriteria Masuk ICCU";
		if (this.signRole === "keluar-dpjp") return "Tanda Tangan Keluar — DPJP";
		return "Tanda Tangan Keluar — PPJA / PJ Shift";
	}

	defaultForm() {
		return {
			km_acs: false,
			km_heart_failure: false,
			km_aritmia: false,
			km_hipertensi_emergency: false,
			km_post_arrest: false,
			km_post_intervensi: false,
			km_transportable: false,
			km_lain: false,
			km_lain_text: "",
			ku_hemodinamik_24jam: false,
			ku_no_iskemia: false,
			ku_spo2_stabil: false,
			ku_kesadaran_baik: false,
			ku_no_invasif: false,
			ku_no_resusitasi: false,
			ku_no_syringe: false,
			ks_acs_bebas_nyeri: false,
			ks_acs_st_stabil: false,
			ks_acs_no_aritmia: false,
			ks_acs_hemodinamik_stabil: false,
			ks_acs_post_pci_lancar: false,
			ks_ahf_no_sesak: false,
			ks_ahf_rr_lt24: false,
			ks_ahf_spo2_gt94: false,
			ks_ahf_diuresis_adekuat: false,
			ks_ahf_no_kongesti: false,
			ks_ahf_elektrolit_stabil: false,
			ks_ar_ritme_stabil: false,
			ks_ar_ventrikel_terkontrol: false,
			ks_ar_alat_pacu_baik: false,
			ks_pca_neurologis_stabil: false,
			ks_pca_hemodinamik_stabil: false,
			ks_pca_napas_baik: false,
			ks_hte_td_stabil: false,
			ks_pi_no_perdarahan: false,
			ks_pi_no_infeksi: false,
			ks_pi_no_aritmia: false,
			ks_pi_no_hipotensi: false,
			ks_pi_observasi_12jam: false,
		};
	}

	@Watch("isActive", { immediate: true })
	onActiveChange(val: boolean) {
		if (val && !this.loaded) {
			this.fetchData();
			this.loaded = true;
		}
	}

	@Watch("item")
	onItemChange() {
		if (this.item) this.populateForm();
	}

	@Watch("form.km_lain")
	onLainChange(val: boolean) {
		if (!val) this.form.km_lain_text = "";
	}

	async fetchData() {
		await storeKriteriaIccu.getByRegister(this.register);
		this.updateStep();
	}

	populateForm() {
		const d = this.item;
		Object.keys(this.form).forEach((key) => {
			if (d[key] !== undefined && d[key] !== null) this.form[key] = d[key];
		});
	}

	updateStep() {
		if (this.phase === "keluar") {
			this.step = 2;
		} else if (this.phase === "masuk") {
			this.step = 1;
		} else {
			this.step = this.isMasukComplete ? 2 : 1;
		}
	}

	async saveDraft() {
		this.saving = true;
		try {
			let resp;
			if (this.item?.id) {
				resp = await KriteriaIccuSvc.update(this.item.id, this.form);
			} else {
				resp = await KriteriaIccuSvc.create({
					...this.form,
					register_id: this.register,
					pasien_rm: this.rm,
				});
			}
			if (resp?.data?.status === "1" && resp.data.data?.id) {
				appModule.NoticeDelay("Berhasil menyimpan Kriteria ICCU");
				await storeKriteriaIccu.refresh(resp.data.data.id);
			}
		} catch (e) {
			// handled by service
		}
		this.saving = false;
	}

	openSign(role: string) {
		if (role === "masuk" && this.masukError) {
			appModule.sendErrorAlert(this.masukError);
			return;
		}
		this.signRole = role;
		this.signPassword = "";
		this.signError = "";
		this.signDialog = true;
	}

	async doSign() {
		if (!this.signPassword) {
			this.signError = "Password harus diisi";
			return;
		}
		this.signing = true;
		this.signError = "";
		try {
			await this.saveDraft();
			if (!this.item?.id) {
				this.signError = "Data harus disimpan terlebih dahulu";
				this.signing = false;
				return;
			}
			const id = this.item.id;
			const payload = { password: this.signPassword };
			let resp;
			if (this.signRole === "masuk") {
				resp = await KriteriaIccuSvc.signMasuk(id, payload);
			} else if (this.signRole === "keluar-dpjp") {
				resp = await KriteriaIccuSvc.signKeluarDpjp(id, payload);
			} else {
				resp = await KriteriaIccuSvc.signKeluarPpja(id, payload);
			}
			if (resp?.data?.status === "1") {
				appModule.NoticeDelay(resp.data.message || "Berhasil menandatangani");
				this.signDialog = false;
				await storeKriteriaIccu.refresh(id);
				this.updateStep();
			}
		} catch (e) {
			this.signError = "Gagal menandatangani. Periksa password Anda.";
		}
		this.signing = false;
	}

	printPdfMasuk() {
		if (this.item?.id) KriteriaIccuSvc.printPdfMasuk(this.item.id);
	}

	printPdfKeluar() {
		if (this.item?.id) KriteriaIccuSvc.printPdfKeluar(this.item.id);
	}

	async doDelete() {
		this.deleting = true;
		try {
			const resp = await KriteriaIccuSvc.destroy(this.item.id);
			if (resp?.data?.status === "1") {
				appModule.NoticeDelay("Berhasil menghapus Kriteria ICCU");
				storeKriteriaIccu.reset();
				this.form = this.defaultForm();
				this.deleteDialog = false;
				this.step = 1;
			}
		} catch (e) {
			// handled by service
		}
		this.deleting = false;
	}

	beforeDestroy() {
		storeKriteriaIccu.reset();
	}
}
